export const dashboardActionTypes = {
    SET_TRIP_DETAILS: 'SET_TRIP_DETAILS',
}

export const setTripDetails = tripDetails => ({
    type: dashboardActionTypes.SET_TRIP_DETAILS,
    payload: tripDetails
})

